import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/lms-profiles.action'
import destroyLmsProfile from 'api/lms-profiles/Delete'
import I18n from 'i18n'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'

async function destroyProfile(profileId: number) {
  return await destroyLmsProfile(profileId)
}

function* lmsProfilesDeleteProfileEffectSaga(action: any) {
  try {
    const { data } = yield call(destroyProfile, action.payload)
    yield put(fromActions.Actions.lmsProfilesDeleteProfileSuccess(data))
    yield put(fromActions.Actions.lmsProfileListReload())
    SuccessToast(I18n.t('administration.toastMessages.profileDeleteSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* lmsProfilesDeleteProfileWatcherSaga() {
  yield takeLatest(fromActions.LMS_PROFILES_DELETE_PROFILE, lmsProfilesDeleteProfileEffectSaga)
}
